// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface EnterpriseEventsV1 {
  id: string;
  userId: number;
  eventKey: string;
  timestamps: Array<number>;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseEventsV1Connection {
  elements: Array<EnterpriseEventsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseEventsV1ByUserQuery {
  EnterpriseEventsV1: {
    byUser: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1ByUserQueryVariables {
  userId: string;
  includes?: string | null;
}

export interface EnterpriseEventsV1DeleteQuery {
  EnterpriseEventsV1: {
    delete: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseEventsV1GetQuery {
  EnterpriseEventsV1: {
    get: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseEventsV1MultiGetQuery {
  EnterpriseEventsV1: {
    multiGet: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseEventsV1AddTimestampMutation {
  EnterpriseEventsV1: {
    addTimestamp: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1AddTimestampMutationVariables {
  id: string;
  timestamp: string;
  includes?: string | null;
}

export interface EnterpriseEventsV1AddTimestampForEventsMutation {
  EnterpriseEventsV1: {
    addTimestampForEvents: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1AddTimestampForEventsMutationVariables {
  ids: string;
  timestamp: string;
  includes?: string | null;
}

export interface EnterpriseEventsV1DeleteByUserMutation {
  EnterpriseEventsV1: {
    deleteByUser: EnterpriseEventsV1Connection | null;
  } | null;
}

export interface EnterpriseEventsV1DeleteByUserMutationVariables {
  userId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseEventsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseEvents.v1' as const;

  declare id: string;

  declare userId: number;

  declare eventKey: string;

  declare timestamps: Array<number>;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseEventsV1>) {
    super(params);
  }
}
